package pnemonic.balloon_pop.view.board

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import pnemonic.balloon_pop.drawable.Level
import pnemonic.balloon_pop.drawable.Teardrop
import pnemonic.balloon_pop.view.theme.AppTheme
import pnemonic.balloon_pop.view.theme.Gold
import pnemonic.balloon_pop.view.theme.panel
import pnemonic.compose.Left

private val colorText = Gold
private val colorCount = Color(0xFFFFDDBB)
private val sizeIcon = 30.dp
private val sizeText = 20.sp

@Composable
fun LevelView(modifier: Modifier = Modifier, level: Int, count: Int) {
    val counterIcon = remember { Teardrop(25f) }

    Row(
        modifier = modifier.panel(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Left
    ) {
        Image(imageVector = Level, contentDescription = "🏁", modifier = Modifier.size(sizeIcon))
        Spacer(modifier = Modifier.width(4.dp))
        Text("$level", color = colorText, fontSize = sizeText)
        Spacer(modifier = Modifier.width(8.dp))
        Image(
            imageVector = counterIcon,
            contentDescription = "⏳",
            modifier = Modifier.size(sizeIcon)
        )
        Spacer(modifier = Modifier.width(4.dp))
        Text("$count", color = colorCount, fontSize = sizeText)
    }
}

@Composable
@Preview
private fun Preview() {
    AppTheme {
        LevelView(level = 123, count = 10)
    }
}

@Composable
@Preview(locale = "he")
private fun Preview_RTL() {
    AppTheme {
        LevelView(level = 456, count = 20)
    }
}